import axios from './index';

class CompanyConfigApi {
  static List = (data) => {
    let query = '?';
    if (data.savingsPlanId) {
      query += `name=${data.savingsPlanId}&`;
    }
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static Create = (data) => {
    let request = {
      name: data.category,
      metal_type: data.type,
      category: data.category,
      short_details: { text: data.description },
      display_order: Number(data.order),
      is_active: data.status === 'true' ? true : false,
    };
    return axios.post(`${base}/`, request);
  };

  static saveAll = (data, companyId) => {
    console.log('data :: ', data, companyId);
    let request = {
      list: data,
    };
    return axios.put(`${base}/${companyId}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.id}`);
  };
  static getById = (id) => {
    return axios.get(`${base}/${id}`);
  };
}

let base = 'dashboard/companyconfig';

export default CompanyConfigApi;
